import React, { useContext, useState } from 'react'

import { useTranslation } from 'react-i18next'
import { Redirect } from 'react-router-dom';

import { DomainContext } from '../../domain-repository/DomainRepository'
import { GroupsImagesContext } from '../../domain-repository/GroupsImagesRepository'

import withLang from '../../withLang'
import DriverInfoHeader from '../../components/PageHeader'
import { FooterWithPrice } from '../../components/Footer'
import TrackingPage from '../../components/TrackingPage'

function UpsellingPage({ history, match }) {
  const { t } = useTranslation();

  const {
    reservation,
    availableUpsellings,
    setUpselling,
    removeUpselling,
    upselling,
    groupsDetails,
    rentalAgreementQuoteValue,
    flowNextRoute,
  } = useContext(DomainContext);

  const { groupsConfigurations } = useContext(GroupsImagesContext);

  const [selectedUpselling, setSelectedVehicle] = useState(upselling.groupID);
  const filteredConfiguredGroups = availableUpsellings
    .filter(up => Object.keys(groupsConfigurations).find(g => g === up.groupID))
    .sort((g1, g2) => g1.dayValueWithTax - g2.dayValueWithTax)

  function getVehicle(vehicleToRender, isReservationVehicle) {
    if (!vehicleToRender) {
      return;
    }

    const groupInfo = groupsDetails.find(g => g.id === vehicleToRender.groupID) || {}

    const isCurrentSelectedVehicle = selectedUpselling
      ? selectedUpselling === vehicleToRender.groupID
      : isReservationVehicle;

    return (
      <div key={vehicleToRender.groupID} className={`board-background mt-2 ${isCurrentSelectedVehicle ? 'active' : ''}`}>
        <div className="row">
          <div className="col-12 col-md-4">
            <div className="resumo-header row">
              <div className="col-6 col-md-12">
                <div className="detail">
                  {t('group')} {vehicleToRender.groupID}
                  <br />
                  <b>{groupInfo.type}</b>
                  <br />
                  {t('orSimilar')}
                </div>
              </div>
              <div className="col-6 col-md-12">
                <img src={groupsConfigurations[vehicleToRender.groupID] && groupsConfigurations[vehicleToRender.groupID].imageUrl} alt={vehicleToRender.groupID} className="img-fluid" />
              </div>
            </div>
          </div>
          <div className="col-12 col-md-8">
            <div className="info-board">
              <div className="row">
                <div className="col-7">
                  <div className="item d-flex align-items-center">
                    <div className="ico"><img src={require('../../assets/images/ico-ocupantes.png')} alt="" /></div>
                    <div className="txt"><b>{t('seats')}:</b> {groupInfo.seats}</div>
                  </div>
                  <div className="item d-flex align-items-center">
                    <div className="ico"><img src={require('../../assets/images/ico-consumo.png')} alt="" /></div>
                    <div className="txt"><b>{t('consumption')}:</b><small> <i>{groupsConfigurations[vehicleToRender.groupID] && groupsConfigurations[vehicleToRender.groupID].consumption}({t(`vehicles-${groupInfo.fuel}`, '')})</i></small></div>
                  </div>            
                  <div className="item d-flex align-items-center">
                    <div className="ico"><img src={require('../../assets/images/ico-transmission.png')} alt="" /></div>
                    <div className="txt"><b>{t('transmisson')}:</b>{t(`vehicles-${groupInfo.transmission}`, '')}</div>
                  </div>                 
                </div>
                <div className="col-5">
                  <div className="item d-flex align-items-center">
                    <div className="ico"><img src={require('../../assets/images/ico-portas.png')} alt="" /></div>
                    <div className="txt"><b>{t('doors')}:</b> {groupInfo.doors}</div>
                  </div>
                  <div className="item d-flex align-items-center">
                    <div className="ico"><img src={require('../../assets/images/ico-big_bag.svg')} alt="" /></div>
                    <div className="txt"><b>{t('bags')}:</b> {groupInfo.bags}</div>
                  </div>
                  <div className="item d-flex align-items-center">
                    <div className="ico"><img src={require('../../assets/images/ico-malas.png')} alt="" /></div>
                    <div className="txt"><b>{t('handbags')}:</b> {groupInfo.handbags}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row justify-content-end">
              <div className="block-value col d-flex align-items-center justify-content-end">
                {isReservationVehicle ?
                  <span className="text-uppercase">{t('yourReservation')}</span> :
                  <span className="text-uppercase">€{vehicleToRender.dayValueWithTax}/{t('day')}</span>
                }
                <button className={!isCurrentSelectedVehicle ? "btn-add" : "btn-check"} onClick={() => {
                  if (isReservationVehicle || isCurrentSelectedVehicle) {
                    setSelectedVehicle('')
                    removeUpselling()
                    return
                  }
                  setSelectedVehicle(vehicleToRender.groupID)
                  setUpselling(vehicleToRender)
                }}></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  function removeReservationGroup(_up, id) {
    return reservation.GroupID !== _up.groupID
  }

  function handleNextClick() {
    /*
    const isUpsellingSpecialGroup = selectedUpselling && groupsDetails.find(g => g.id === selectedUpselling && g.special) !== undefined
    if (isUpsellingSpecialGroup) {
      saveSessionStationObservations('[Kiosk: Última página - Upgrade (Upgrade grupo especial)]')
        .then(_ => {
          setExitUpSellingModal(true)
        })
        .catch(_ => {
          setExitUpSellingModal(true)
        })
    } else {
      history.location.state && history.location.state.continueUrl ? history.push(history.location.state.continueUrl) : history.push('/comfort-extras')
    }
    */
    history.location.state && history.location.state.continueUrl ? history.push(history.location.state.continueUrl) : history.push('/comfort-extras')
  }

  return filteredConfiguredGroups.length > 0 ? (
    <div>
      <DriverInfoHeader
        title={t('comfort')}
        active={2}
        progress={'55%'}
        handleLogoClick={() => history.push('/start')}
      />
      <main>
        <div className="container">
          <div className="main">
            <div className="header text-center">
              <div className="text-center">
                <h2>{t('upsellingTitle')}</h2>
              </div>
            </div>
            <div className="block-container">
              {getVehicle({ groupID: reservation.GroupID }, true)}
              {filteredConfiguredGroups.filter(removeReservationGroup).map(_up =>
                getVehicle(_up)
              )}
            </div>
          </div>
        </div>
        <FooterWithPrice
          totalPrice={rentalAgreementQuoteValue}
          totalPriceLabel={t('total')}
          handleNextClick={() => history.push(flowNextRoute(match.path))}
          handlePrevClick={() => history.goBack()}
        />
      </main>
    </div>
  ) : <Redirect to={history.location.state && history.location.state.continueUrl ? history.location.state.continueUrl : "/comfort-extras"} />
}

export default withLang(TrackingPage(UpsellingPage, 23))
